// extracted by mini-css-extract-plugin
module.exports = {"Card":"card_Card__34aUB","front":"card_front__1pIMg","power":"card_power__1hqi3","gender_down":"card_gender_down__1JBS-","back":"card_back__zNtgV"};